import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { App } from './App';
import { AuthProvider } from './lib/auth/AuthContext';
import { MarcaAtivaProvider } from './lib/auth/MarcaAtiva';

import './styles/tokens.css';
import './styles/painel.css';
import './styles/app.css';

/**
 * <h3>Sem retentativa automática, de propósito</h3>
 * O padrão do TanStack Query é tentar de novo três vezes. Num painel de operação isso é
 * ruim duas vezes: esconde a falha por alguns segundos — a pessoa vê a tela travada e não
 * sabe se está carregando ou quebrado — e transforma um 403 legítimo em quatro requisições
 * recusadas, enchendo o log de segurança de ruído.
 *
 * <p>Erro aqui aparece na hora, com a mensagem do catálogo do servidor.
 */
const consultas = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 15_000,
    },
  },
});

const raiz = document.getElementById('root');
if (!raiz) {
  throw new Error('elemento #root ausente no index.html');
}

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={consultas}>
      <BrowserRouter>
        <AuthProvider>
          <MarcaAtivaProvider>
            <App />
          </MarcaAtivaProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
